/* 021 Originals — PDP variant B behaviour.
   Gallery, variant selection, delivery estimate, cart add. No dependencies. */
(function () {
  'use strict';

  /* Every og-pdp-* section emits its own <script src="og-pdp.js">, because a
     section has to be self-contained to survive being added or removed in the
     theme editor. The browser caches the fetch but EXECUTES each tag, so with
     four sections on the page this file ran four times and bound four copies of
     every document-level listener. The accordion toggled four times per click —
     an even number, so it visibly did nothing. Initialise once.
     (Add-to-cart escaped this only because handleAdd calls
     stopImmediatePropagation, which is luck, not design.) */
  if (window.__ogPdpInit) return;
  window.__ogPdpInit = true;

  /* ------------------------------------------------------------ accordions
     Bound at document level and BEFORE the buy-box guard below, so the
     accordions section still works on a template that has no buy box.
     Opening one closes the others (QA-CHECKLIST §C). */
  /* The design's accordion animates max-height inline — the design system ships
     it as a JS component, so there is no .is-open class anywhere in its CSS to
     hook. Matching that mechanic rather than toggling [hidden], which would
     snap open with no transition and fight the ported styles. */
  function accSet(item, open) {
    var head = item.querySelector('[data-og-acc-toggle]');
    var panel = item.querySelector('[data-og-acc-panel]');
    if (!head || !panel) return;
    head.setAttribute('aria-expanded', open ? 'true' : 'false');
    item.classList.toggle('is-open', open);
    /* scrollHeight, not a fixed value: panels hold images and wrapped copy of
       unknown height, and a guessed max-height clips the tallest one. */
    panel.style.maxHeight = open ? panel.scrollHeight + 'px' : '0px';
  }

  document.addEventListener('click', function (e) {
    var head = e.target.closest('[data-og-acc-toggle]');
    if (!head) return;
    e.preventDefault();
    var item = head.closest('.og-acc__item');
    if (!item) return;
    var opening = head.getAttribute('aria-expanded') !== 'true';

    /* Opening one closes the rest of ITS group (QA-CHECKLIST §C). Scoped to the
       nearest group so the buy box, build and FAQ accordions stay independent. */
    var group = item.closest('[data-og-accordions]') || item.closest('.og-acc');
    if (group) {
      group.querySelectorAll('.og-acc__item').forEach(function (other) {
        if (other !== item) accSet(other, false);
      });
    }
    accSet(item, opening);
  });

  /* A panel opened before its images finish loading would keep a max-height
     measured too short and clip. Re-measure whatever is open on load/resize. */
  function accRemeasure() {
    document.querySelectorAll('.og-acc__item.is-open').forEach(function (item) {
      var panel = item.querySelector('[data-og-acc-panel]');
      if (panel) panel.style.maxHeight = panel.scrollHeight + 'px';
    });
  }
  window.addEventListener('load', accRemeasure);
  window.addEventListener('resize', accRemeasure, { passive: true });

  /* ------------------------------------------------------- product strips
     Flavors and FBT share the design's .flav-strip component with its own
     left/right scroll buttons. Bound at document level and before the buy-box
     guard so the strips work on any template. Buttons disable at each end
     rather than scrolling into empty space (QA-CHECKLIST §C). */
  (function () {
    var wraps = document.querySelectorAll('.strip-wrap');
    if (!wraps.length) return;

    wraps.forEach(function (wrap) {
      var track = wrap.querySelector('[data-og-strip-track]');
      var prev = wrap.querySelector('[data-og-strip-prev]');
      var next = wrap.querySelector('[data-og-strip-next]');
      if (!track) return;

      function sync() {
        var max = track.scrollWidth - track.clientWidth;
        var atStart = track.scrollLeft <= 1;
        var atEnd = track.scrollLeft >= max - 1;
        /* Hide rather than disable when the strip does not overflow at all —
           two dead arrows on a short collection read as broken. */
        var scrollable = max > 2;
        if (prev) { prev.hidden = !scrollable; prev.disabled = atStart; }
        if (next) { next.hidden = !scrollable; next.disabled = atEnd; }
      }

      function page(dir) {
        var first = track.querySelector('.flav');
        var step = first ? first.getBoundingClientRect().width + 12 : track.clientWidth * 0.8;
        track.scrollBy({ left: dir * step * 2, behavior: 'smooth' });
      }

      if (prev) prev.addEventListener('click', function () { page(-1); });
      if (next) next.addEventListener('click', function () { page(1); });
      track.addEventListener('scroll', sync, { passive: true });
      window.addEventListener('resize', sync, { passive: true });
      sync();
    });
  })();

  var root = document.querySelector('[data-og-buybox]');
  if (!root) return;

  /* ---------------------------------------------------------------- variants */
  var variants = [];
  try { variants = JSON.parse(root.querySelector('[data-og-variants]').textContent); } catch (e) { variants = []; }

  var selected = [];
  root.querySelectorAll('[data-og-opt].og-swatch--selected, [data-og-opt].og-size--on').forEach(function (b) {
    selected[parseInt(b.getAttribute('data-og-opt'), 10)] = b.getAttribute('data-og-val');
  });

  function findVariant(opts) {
    for (var i = 0; i < variants.length; i++) {
      var v = variants[i], ok = true;
      for (var j = 0; j < opts.length; j++) { if (v.options[j] !== opts[j]) { ok = false; break; } }
      if (ok) return v;
    }
    return null;
  }
  /* The exact pairing, never a nearest-match: a control must describe the variant it
     would actually produce, or it advertises a price you cannot buy. */
  function exactFor(index, value) {
    var probe = selected.slice();
    probe[index] = value;
    return findVariant(probe);
  }

  function setText(sel, text) {
    root.querySelectorAll(sel).forEach(function (el) { el.textContent = text; });
  }

  function render(v) {
    if (!v) return;

    setText('[data-og-price]', v.price_fmt);

    /* Compare-at price and savings badges. Driven off the variant payload so a
       colourway on sale and one at full price show the right thing as you click
       between them. Elements only exist when their setting is on, so presence is
       the on/off switch and this only has to decide sale vs not. */
    var cmpCents = typeof v.compare_cents === 'number' ? v.compare_cents : 0;
    var nowCents = typeof v.price_cents === 'number' ? v.price_cents : 0;
    var onSale = cmpCents > nowCents;
    /* The whole price group moves to its own line when there are badges, so the
       class has to follow the variant, not just the first paint. */
    var priceBox = root.querySelector('[data-og-pricebox]');
    if (priceBox) priceBox.classList.toggle('bb-price--sale', onSale);
    /* The row only wraps on sale. Wrapping it unconditionally let the title grow
       to the full column and pushed a plain price onto its own line at 390. */
    var titleRow = root.querySelector('[data-og-titlerow]');
    if (titleRow) titleRow.classList.toggle('bb-titlerow--sale', onSale);
    var wasEl = root.querySelector('[data-og-was]');
    if (wasEl) {
      wasEl.hidden = !onSale;
      if (onSale) wasEl.textContent = v.compare_fmt || formatMoney(cmpCents);
    }
    var saveEl = root.querySelector('[data-og-save]');
    if (saveEl) {
      saveEl.hidden = !onSale;
      if (onSale) {
        saveEl.textContent = (saveEl.getAttribute('data-tpl') || 'Save [amount]')
          .replace('[amount]', formatMoney(cmpCents - nowCents));
      }
    }
    var pctEl = root.querySelector('[data-og-pct]');
    if (pctEl) {
      pctEl.hidden = !onSale;
      if (onSale) {
        /* Floor, matching the Liquid that rendered the first paint. Rounding up
           here would make the badge jump by a point on the first variant click. */
        var pct = Math.floor((cmpCents - nowCents) * 100 / cmpCents);
        pctEl.textContent = (pctEl.getAttribute('data-tpl') || '[percent]% OFF')
          .replace('[percent]', pct);
      }
    }
    /* The instalment is NOT set here. It depends on quantity as well as variant,
       so syncQty() owns it and is called at the end of this function once
       data-unit-price has been updated below. Setting v.instalment_fmt here too
       would briefly show the single-unit figure. */

    /* Model line is absent for colourways with no shoot. Hide the whole line
       rather than leaving a dangling "Our model". */
    root.querySelectorAll('[data-og-model], [data-og-model-desk]').forEach(function (el) {
      el.hidden = !v.model_line;
    });
    /* Split the sheet's sentence so the model's name stays bold, matching the
       markup Liquid rendered on load. */
    if (v.model_line) {
      var sp = v.model_line.indexOf(' ');
      var nm = sp > 0 ? v.model_line.slice(0, sp) : v.model_line;
      var rest = sp > 0 ? v.model_line.slice(sp + 1) : '';
      setText('[data-og-model-name]', nm);
      setText('[data-og-model-text]', rest);
    }

    /* There are now two Add to Cart buttons — the main one and the mobile sticky
       bar — so update every one of them. Keeping the sticky button stale would
       let a shopper add the previously selected variant. */
    root.querySelectorAll('[data-og-add]').forEach(function (add) {
      add.setAttribute('data-variant-id', v.id);
      if (typeof v.price_cents === 'number') add.setAttribute('data-unit-price', v.price_cents);
      add.disabled = !v.available;
      var label = add.querySelector('[data-og-add-label]');
      if (label) {
        /* textContent alone would wipe the price <span> that lives inside this
           label, so the amount vanished from the button on any variant change.
           Rebuild the slot rather than assuming it survived. */
        label.textContent = v.available ? (add.getAttribute('data-label') || 'Add to Cart') : 'Sold Out';
        if (v.available && add.hasAttribute('data-show-price')) {
          var slot = document.createElement('span');
          slot.className = 'og-btn__price';
          slot.setAttribute('data-og-atc-price', '');
          label.appendChild(slot);
        }
      }
    });
    /* After the labels are rebuilt, so the fresh slots get filled. */
    syncQty();

    /* Re-filter the gallery to the newly selected colourway, then move to its
       first image. The previous call passed quiet=true, which set the desktop
       main image but never scrolled the mobile strip — so on mobile the gallery
       stayed wherever it was and appeared not to respond to the swatch. */
    var newColour = v.options[colourIndexForFilter];
    var firstOfColour = filterGallery(newColour);
    var target = typeof v.media_index === 'number' ? v.media_index : firstOfColour;
    if (target !== null && slides[target] && slides[target].hidden) target = firstOfColour;
    if (target !== null && target !== undefined) goTo(target);

    if (window.history && window.history.replaceState) {
      var url = new URL(window.location.href);
      url.searchParams.set('variant', v.id);
      window.history.replaceState({}, '', url.toString());
    }
    document.dispatchEvent(new CustomEvent('variant:changed', { bubbles: true, detail: { variant: v } }));
  }

  function paint() {
    root.querySelectorAll('[data-og-opt]').forEach(function (btn) {
      var index = parseInt(btn.getAttribute('data-og-opt'), 10);
      var value = btn.getAttribute('data-og-val');
      var isSel = selected[index] === value;
      /* The design marks state with og-swatch--selected / og-size--on, not a
         shared .is-sel. Toggle whichever applies to this control. */
      if (btn.classList.contains('og-swatch')) btn.classList.toggle('og-swatch--selected', isSel);
      if (btn.classList.contains('og-size')) btn.classList.toggle('og-size--on', isSel);
      btn.setAttribute('aria-checked', isSel ? 'true' : 'false');

      var exact = exactFor(index, value);
      if (btn.classList.contains('og-size')) {
        /* Size is judged against the EXACT pairing: this colour in this size. */
        btn.classList.toggle('og-size--out', !exact || !exact.available);
      }
      if (btn.classList.contains('og-swatch')) {
        /* A colour is only "out" when every size of it is gone. Marking a colour
           out because it is unavailable in the currently-selected size would
           strike through most of the row and hide colours the shopper can
           actually buy in another size. */
        var anyLeft = false;
        for (var k = 0; k < variants.length; k++) {
          if (variants[k].options[index] === value && variants[k].available) { anyLeft = true; break; }
        }
        btn.classList.toggle('og-swatch--out', !anyLeft);
        btn.setAttribute('aria-disabled', anyLeft ? 'false' : 'true');
        if (!anyLeft) btn.title = value + ' — sold out';
      }
    });
    var colourBtn = root.querySelector('.og-swatch--selected');
    if (colourBtn) setText('[data-og-colour-label]', colourBtn.getAttribute('data-og-val'));
    var sizeBtn = root.querySelector('.og-size--on');
    if (sizeBtn) {
      /* The label shows the word ("Medium"), the chip keeps the code ("M"). */
      var raw = sizeBtn.getAttribute('data-og-val');
      var lbl = root.querySelector('[data-og-size-label]');
      var out = raw;
      if (lbl) {
        var map = lbl.getAttribute('data-og-size-names') || '';
        map.split('\n').forEach(function (row) {
          var bits = row.split(':');
          if (bits.length === 2 && bits[0].trim().toUpperCase() === String(raw).toUpperCase()) {
            out = bits[1].trim();
          }
        });
      }
      setText('[data-og-size-label]', out);
    }
  }

  root.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-og-opt]');
    if (!btn) return;
    e.preventDefault();
    var index = parseInt(btn.getAttribute('data-og-opt'), 10);
    var value = btn.getAttribute('data-og-val');
    if (selected[index] === value) return;
    selected[index] = value;

    var target = findVariant(selected);

    /* Changing colour can leave the previously-chosen size sold out in the new
       colourway — Add to Cart then reads "Sold Out" and dead-ends even though
       other sizes are in stock. If the shopper changed COLOUR and the resulting
       pairing is unavailable, move the size to the first one that is buyable in
       that colour. The colour they just clicked is never overridden. */
    if (btn.classList.contains('og-swatch') && (!target || !target.available)) {
      for (var s2 = 0; s2 < variants.length; s2++) {
        if (variants[s2].options[index] === value && variants[s2].available) {
          selected = variants[s2].options.slice();
          target = variants[s2];
          break;
        }
      }
    }

    /* If the pairing does not exist, slide only the OTHER option to something real
       rather than silently reverting the choice the shopper just made. */
    if (!target) {
      for (var i = 0; i < variants.length; i++) {
        if (variants[i].options[index] === value && variants[i].available) { target = variants[i]; break; }
      }
      if (target) selected = target.options.slice();
    }
    paint();
    render(target);
  });

  /* ---------------------------------------------------------------- gallery */
  var current_index = 0;
  var strip = root.querySelector('[data-og-strip]');
  var mainImg = root.querySelector('[data-og-mainimg]');
  var slides = root.querySelectorAll('[data-og-slide]');

  /* ---------------------------------------------- colourway image filtering
     Every media item on this product carries the colourway as its ALT text
     ("BLACK", "SEA FOAM", …) — 64 images across 16 colours. That is the same
     convention the theme's own enable_var_img_grouping uses, so the mapping
     already exists in Shopify and nothing has to be maintained by hand: adding a
     colourway with correctly-alted photos just works.

     Media whose alt matches no colour option (or has none) is treated as shared
     and shown for every colour, so an un-alted lifestyle shot is never orphaned.

     Without this the gallery held all 64 images at once, so choosing a colour
     left you looking at whichever slide you were already on — the reported
     "stays on the black image". */
  var colourIndexForFilter = -1;
  (function () {
    var anySwatch = root.querySelector('.og-swatch[data-og-opt]');
    if (anySwatch) colourIndexForFilter = parseInt(anySwatch.getAttribute('data-og-opt'), 10);
  })();

  var colourValues = {};
  root.querySelectorAll('.og-swatch[data-og-val]').forEach(function (b) {
    colourValues[(b.getAttribute('data-og-val') || '').trim().toUpperCase()] = true;
  });

  function mediaColour(el) { return (el.getAttribute('data-og-mcolour') || '').trim().toUpperCase(); }

  function belongsTo(el, colour) {
    var c = mediaColour(el);
    if (!c) return true;                 // untagged -> shared
    if (!colourValues[c]) return true;   // alt is not a colourway -> shared
    return c === colour;
  }

  function filterGallery(colour) {
    colour = (colour || '').trim().toUpperCase();
    if (!colour) return null;
    var first = null;
    slides.forEach(function (img, i) {
      var show = belongsTo(img, colour);
      img.hidden = !show;
      if (show && first === null) first = i;
    });
    root.querySelectorAll('[data-og-goto]').forEach(function (btn) {
      btn.hidden = !belongsTo(btn, colour);
    });
    return first;
  }

  function goTo(i, quiet) {
    if (i < 0 || i >= slides.length) return;
    if (slides[i] && slides[i].hidden) return;   /* never target a filtered-out slide */
    current_index = i;
    if (mainImg && slides[i]) mainImg.src = slides[i].src;
    markActive(i);
    if (!quiet && strip && slides[i]) {
      strip.scrollTo({ left: slides[i].offsetLeft - strip.offsetLeft, behavior: 'smooth' });
    }
  }

  root.querySelectorAll('[data-og-goto]').forEach(function (b) {
    b.addEventListener('click', function () { goTo(parseInt(b.getAttribute('data-og-goto'), 10)); });
  });

  /* Desktop main-image arrows (.car-arrow--l / --r). Absent from the earlier
     hand-built gallery entirely. Index is tracked here rather than read back
     from the DOM so it stays correct when a variant change jumps the gallery. */
  root.querySelectorAll('[data-og-arrow]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var dir = parseInt(btn.getAttribute('data-og-arrow'), 10) || 1;
      var count = slides.length;
      if (!count) return;
      /* Step to the next VISIBLE slide: the gallery is filtered to one colourway,
         so a plain +1 would land on a hidden image and appear to do nothing. */
      var i = current_index;
      for (var n = 0; n < count; n++) {
        i = (i + dir + count) % count;
        if (!slides[i].hidden) break;
      }
      goTo(i, true);
    });
  });

  /* Which slides are actually on screen for the current colourway, as ABSOLUTE
     media indexes. The gallery is filtered per colour, so the Nth visible slide
     is rarely the Nth media item. */
  function visibleIndexes() {
    var out = [];
    slides.forEach(function (sl, i) {
      if (getComputedStyle(sl).display !== 'none') out.push(i);
    });
    return out;
  }

  function markActive(absIndex) {
    root.querySelectorAll('[data-og-goto]').forEach(function (b) {
      b.classList.toggle('on', parseInt(b.getAttribute('data-og-goto'), 10) === absIndex);
    });
  }

  if (strip) {
    var tick;
    strip.addEventListener('scroll', function () {
      window.clearTimeout(tick);
      tick = window.setTimeout(function () {
        /* The scroll position gives a page number among the VISIBLE slides.
           Comparing that directly to data-og-goto — an absolute media index —
           only ever matched for BLACK, whose media happens to start at 0. For
           every other colourway no dot matched, so the active marker vanished
           and there was no indication of position. Map the page back to its
           absolute index first. */
        var vis = visibleIndexes();
        if (!vis.length) return;
        var page = Math.round(strip.scrollLeft / strip.clientWidth);
        page = Math.max(0, Math.min(page, vis.length - 1));
        markActive(vis[page]);
      }, 80);
    }, { passive: true });
  }

  /* ------------------------------------------------------------ rating link
     The markup anchors to #og-reviews, which nothing defines — the reviews block
     is a Loox app block whose section id is generated, so it cannot be hardcoded
     here without breaking the moment the block is re-added. Resolve the Loox
     container at click time and fall back to doing nothing rather than jumping
     the shopper to the top of the page. */
  (function () {
    var stars = root.querySelector('.bb-stars');
    if (!stars) return;
    stars.addEventListener('click', function (e) {
      var target = document.querySelector(
        '#looxReviews, [id^="looxReviews"], .loox-reviews-default, .loox-reviews'
      );
      if (!target) { e.preventDefault(); return; }
      var section = target.closest('.shopify-section') || target;
      e.preventDefault();
      section.scrollIntoView({ behavior: 'smooth', block: 'start' });
    });
  })();


  /* ------------------------------------------------------------ drag to swipe
     The strip is overflow-x:auto, so a trackpad or a real touch flick already
     scrolls it — but pressing and dragging with a finger or mouse did nothing,
     which is what a shopper actually tries on a photo. The design's CSS sets
     cursor:grab and user-select:none on .car-strip, so pointer dragging is the
     intended interaction and was simply never wired up.

     Pointer Events cover mouse, touch and pen in one path. scroll-snap is
     suspended during the drag, otherwise every pointermove fights the snap and
     the strip jitters; it is restored on release so the flick still settles on
     an image. */
  /* The design marks .car-strip, .why-grid and .flav-strip all with cursor:grab
     and user-select:none — every one of them is meant to be draggable. Only the
     gallery was wired up, which is why the why-cards could not be dragged. */
  var gallery = strip;
  function makeDraggable(strip) {
    if (!strip) return;
    var dragging = false, startX = 0, startScroll = 0, moved = 0;

    strip.addEventListener('pointerdown', function (e) {
      /* Touch already scrolls an overflow-x container natively. Running the
         custom drag as well would move the strip twice per gesture, so this
         handles mouse and pen only — which is exactly the case that was dead:
         press-and-drag on the photo did nothing. */
      if (e.pointerType === 'touch') return;
      if (e.pointerType === 'mouse' && e.button !== 0) return;
      dragging = true; moved = 0;
      startX = e.clientX;
      startScroll = strip.scrollLeft;
      strip.style.scrollSnapType = 'none';
      strip.style.cursor = 'grabbing';
    });

    strip.addEventListener('pointermove', function (e) {
      if (!dragging) return;
      var dx = e.clientX - startX;
      if (Math.abs(dx) > 3) {
        /* Only capture once it is clearly a drag, so a plain tap still behaves
           like a tap and vertical page scrolling is not hijacked. */
        if (!moved && strip.setPointerCapture) { try { strip.setPointerCapture(e.pointerId); } catch (err) {} }
        moved = Math.abs(dx);
        e.preventDefault();
      }
      strip.scrollLeft = startScroll - dx;
    });

    function endDrag() {
      if (!dragging) return;
      dragging = false;
      strip.style.cursor = '';
      strip.style.scrollSnapType = '';
      /* Only the gallery snaps to a slide and syncs the dots; the card rows are
         free-scrolling and must keep wherever the drag left them. */
      if (strip !== gallery) return;
      var i = Math.round(strip.scrollLeft / strip.clientWidth);
      var visible = [];
      slides.forEach(function (sl, idx) { if (getComputedStyle(sl).display !== 'none') visible.push(idx); });
      var target = visible[Math.max(0, Math.min(i, visible.length - 1))];
      if (typeof target === 'number') goTo(target);
    }
    strip.addEventListener('pointerup', endDrag);
    strip.addEventListener('pointercancel', endDrag);
    strip.addEventListener('pointerleave', endDrag);
    /* A drag that ends on an image must not follow it as a click. */
    strip.addEventListener('click', function (e) { if (moved > 5) { e.preventDefault(); e.stopPropagation(); } }, true);
  }

  makeDraggable(strip);
  document.querySelectorAll('.why-grid, .flav-strip').forEach(makeDraggable);

  /* ------------------------------------------------- delivery estimate
     Computed in the browser, not Liquid: Shopify caches pages, so a rendered
     date would go stale and start promising deliveries in the past. Weekends
     are skipped; public holidays are NOT handled. */
  (function () {
    var target = root.querySelector('[data-og-delivery]');
    var plain = document.querySelectorAll('[data-og-delivery-plain]');
    /* Don't bail on a missing trust row — the shipping modal needs the same
       window even when the buy box has no delivery trust item configured. */
    if (!target && !plain.length) return;
    var min = parseInt(root.getAttribute('data-ship-min') || '4', 10);
    var max = parseInt(root.getAttribute('data-ship-max') || '6', 10);

    function addBusinessDays(from, n) {
      var d = new Date(from.getTime()), added = 0;
      while (added < n) {
        d.setDate(d.getDate() + 1);
        var wd = d.getDay();
        if (wd !== 0 && wd !== 6) added++;
      }
      return d;
    }
    function fmt(d) {
      return String(d.getMonth() + 1).padStart(2, '0') + '/' + String(d.getDate()).padStart(2, '0');
    }
    var now = new Date();
    var window_ = fmt(addBusinessDays(now, min)) + '–' + fmt(addBusinessDays(now, max));
    if (target) target.textContent = 'Expected delivery ' + window_;
    /* The shipping modal shows the same window with its own label around it. */
    plain.forEach(function (el) { el.textContent = window_; });
  })();

  /* ---------------------------------------------------------------- modals
     The design uses .pmodal (a div), not <dialog>: its CSS makes .pm-panel a
     bottom sheet on mobile (border-radius 18px 18px 0 0 + the pm-up animation)
     and a centred card on desktop. Driving it with a div means supplying the
     focus handling and Escape that <dialog> gave for free. */
  (function () {
    var lastFocus = null;

    function openModal(name) {
      var m = document.querySelector('[data-og-dialog="' + name + '"]');
      if (!m) return;
      lastFocus = document.activeElement;
      m.hidden = false;
      /* Lock BOTH: setting it on documentElement alone left document.body
         scrollable, so the page still moved behind an open sheet. */
      document.documentElement.style.overflow = 'hidden';
      document.body.style.overflow = 'hidden';
      var focusable = m.querySelector('.pm-x');
      if (focusable) focusable.focus();
    }

    function closeModal(m) {
      if (!m || m.hidden) return;
      m.hidden = true;
      if (!document.querySelector('.pmodal:not([hidden])')) {
        document.documentElement.style.overflow = '';
        document.body.style.overflow = '';
      }
      if (lastFocus && lastFocus.focus) lastFocus.focus();
    }

    document.addEventListener('click', function (e) {
      var trigger = e.target.closest('[data-og-modal]');
      if (trigger) {
        var name = trigger.getAttribute('data-og-modal');
        if (name && name !== 'none') { e.preventDefault(); openModal(name); return; }
      }
      /* Scrim and the X both carry data-og-modal-close. */
      var closer = e.target.closest('[data-og-modal-close]');
      if (closer) { e.preventDefault(); closeModal(closer.closest('.pmodal')); }
    });

    document.addEventListener('keydown', function (e) {
      if (e.key !== 'Escape') return;
      closeModal(document.querySelector('.pmodal:not([hidden])'));
    });

    /* Keep focus inside the open sheet. */
    document.addEventListener('keydown', function (e) {
      if (e.key !== 'Tab') return;
      var m = document.querySelector('.pmodal:not([hidden])');
      if (!m) return;
      var items = m.querySelectorAll('a[href], button:not([disabled]), input, [tabindex]:not([tabindex="-1"])');
      if (!items.length) return;
      var first = items[0], last = items[items.length - 1];
      if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
      else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
    });

    /* Size-guide unit toggle. Both ranges are rendered server side and swapped
       here, so no request and no reflow of the grid. */
    var sizeDlg = document.querySelector('[data-og-dialog="size"]');
    if (sizeDlg) {
      sizeDlg.addEventListener('click', function (e) {
        var btn = e.target.closest('[data-og-unit]');
        if (!btn) return;
        var unit = btn.getAttribute('data-og-unit');
        sizeDlg.querySelectorAll('[data-og-unit]').forEach(function (b) { b.classList.toggle('on', b === btn); });
        sizeDlg.querySelectorAll('[data-og-range-lbs]').forEach(function (el) { el.hidden = unit !== 'lbs'; });
        sizeDlg.querySelectorAll('[data-og-range-kgs]').forEach(function (el) { el.hidden = unit !== 'kgs'; });
        sizeDlg.querySelectorAll('[data-og-unit-label]').forEach(function (el) { el.textContent = unit; });
      });
    }
  })();


  /* ------------------------------------------------------------ quantity
     Client addition (not in the design). data-og-qty is the single source of
     truth: handleAdd reads it, and the button's amount is recomputed from it,
     so the figure on the button is always the line total that will be charged.
     Money is formatted from the pre-formatted Liquid strings where possible;
     for multiples the amount is composed from the variant's unit price in
     cents so the JS never invents currency formatting rules. */
  var qtyInput = root.querySelector('[data-og-qty]');

  function currentQty() {
    if (!qtyInput) return 1;
    var n = parseInt(qtyInput.value, 10);
    if (!n || n < 1) n = 1;
    var max = parseInt(qtyInput.getAttribute('max'), 10) || 10;
    if (n > max) n = max;
    return n;
  }

  function formatMoney2dp(cents) {
    /* Matches Liquid's `| money`, which the Afterpay line was rendered with:
       always two decimals. Afterpay quotes instalments to the cent. */
    var parts = (Math.round(cents) / 100).toFixed(2).split('.');
    return '$' + parts[0].replace(/\B(?=(\d{3})+$)/g, ',') + '.' + parts[1];
  }

  function formatMoney(cents) {
    /* Mirror money_without_trailing_zeros: drop .00, keep real cents. */
    var whole = Math.round(cents) / 100;
    var s = whole % 1 === 0 ? String(whole) : whole.toFixed(2);
    return '$' + s.replace(/\B(?=(\d{3})+(?!\d))/, ',');
  }

  function syncQty() {
    var n = currentQty();
    if (qtyInput) {
      qtyInput.value = n;
      var max = parseInt(qtyInput.getAttribute('max'), 10) || 10;
      root.querySelectorAll('[data-og-qty-step]').forEach(function (b) {
        var dir = parseInt(b.getAttribute('data-og-qty-step'), 10);
        b.disabled = (dir < 0 && n <= 1) || (dir > 0 && n >= max);
      });
    }
    root.querySelectorAll('[data-og-add][data-show-price]').forEach(function (btn) {
      var unit = parseInt(btn.getAttribute('data-unit-price'), 10);
      var slot = btn.querySelector('[data-og-atc-price]');
      if (slot && !isNaN(unit)) slot.textContent = ' \u00b7 ' + formatMoney(unit * n);
    });

    /* Afterpay instalment. It was fixed at the single-unit figure, so adding 4
       shirts advertised "4 payments of $7.00" against a $112 order. Afterpay
       splits the LINE total, so it has to track quantity as well as variant.
       Read the unit price off any Add to Cart button — render() keeps
       data-unit-price current, and this runs after it. */
    var priced = root.querySelector('[data-og-add][data-unit-price]');
    var unitPrice = priced ? parseInt(priced.getAttribute('data-unit-price'), 10) : NaN;
    if (!isNaN(unitPrice)) {
      setText('[data-og-instalment]', formatMoney2dp(unitPrice * n / 4));
    }
  }

  root.addEventListener('click', function (e) {
    var step = e.target.closest('[data-og-qty-step]');
    if (!step || !qtyInput) return;
    e.preventDefault();
    qtyInput.value = currentQty() + parseInt(step.getAttribute('data-og-qty-step'), 10);
    syncQty();
  });
  if (qtyInput) {
    qtyInput.addEventListener('change', syncQty);
    qtyInput.addEventListener('blur', syncQty);
  }
  syncQty();

  /* ---------------------------------------------------------------- cart add
     Capture phase, and a <button type="button"> rather than a form submit:
     cart apps commonly delegate off form submits and replace the payload. */
  function handleAdd(e) {
    /* Use the button that was actually clicked. Resolving the first
       [data-og-add] in the section would make the mobile sticky bar add whatever
       the main button was showing, and would flash "Added" on the wrong control. */
    var btn = e.currentTarget && e.currentTarget.closest
      ? e.currentTarget.closest('[data-og-add]')
      : null;
    if (!btn) btn = e.target.closest('[data-og-add]');
    if (!btn || btn.disabled) return;
    e.preventDefault();
    e.stopPropagation();
    if (e.stopImmediatePropagation) e.stopImmediatePropagation();

    var id = parseInt(btn.getAttribute('data-variant-id'), 10);
    if (!id) return;
    var label = btn.querySelector('[data-og-add-label]');
    var original = label ? label.textContent : '';

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: [{ id: id, quantity: currentQty() }] })
    }).then(function (r) { return r.json(); }).then(function (data) {
      if (label) { label.textContent = 'Added ✓'; window.setTimeout(function () { label.textContent = original; }, 1800); }

      /* This theme's cart contract is `theme:cartchanged`, dispatched on
         documentElement. The header binds $(document).on('theme:cartchanged…')
         and re-fetches ?sections=header to repaint the cart count; the cart-drawer
         component binds the same event and refreshes itself, opening when
         detail.openDrawer is set. The generic cart:* events below are what other
         cart apps listen for and are kept as a belt-and-braces fallback, but
         nothing in this theme listens to them — which is why the cart icon
         previously did not update until a manual page reload.
         openDrawer:true mirrors the theme's own post-add behaviour under
         cart_type = drawer, so B gives the same feedback as control A. */
      document.documentElement.dispatchEvent(new CustomEvent('theme:cartchanged', {
        bubbles: true, cancelable: false, detail: { openDrawer: true }
      }));

      ['cart:refresh', 'cart:added', 'cart:open'].forEach(function (n) {
        document.dispatchEvent(new CustomEvent(n, { bubbles: true, detail: data }));
        window.dispatchEvent(new CustomEvent(n, { detail: data }));
      });
    }).catch(function () {
      if (label) label.textContent = original;
    });
  }
  /* data-label is authored by Liquid from the schema setting. Do NOT re-derive it
     from the rendered label here: on an out-of-stock first variant that text is
     "Sold Out", which would then be reused as the in-stock label. */
  root.querySelectorAll('[data-og-add]').forEach(function (b) {
    b.addEventListener('click', handleAdd, true);
  });

  /* ------------------------------------------------------------ sticky ATC
     Driven by an IntersectionObserver on the real Add to Cart rather than a
     scroll offset: the gallery height varies with the number of media items, so
     any fixed threshold would be wrong on some products. Hidden on load, shown
     once the real button leaves the viewport, hidden again on the way back up
     (QA-CHECKLIST §C). */
  (function () {
    var bar = document.querySelector('[data-og-sticky]');
    var anchor = root.querySelector('.bb-atcrow [data-og-add]');
    if (!bar || !anchor) return;

    function show(on) {
      if (bar.classList.contains('on') === on) return;
      /* The design drives this with .on -> transform:none, so the bar slides up
         rather than appearing. [hidden] would kill the transition outright. */
      bar.classList.toggle('on', on);
      bar.setAttribute('aria-hidden', on ? 'false' : 'true');
    }

    /* Measured on scroll rather than via IntersectionObserver. An observer only
       fires when the element CROSSES a threshold, so jumping straight past the
       button — an anchor link, a restored scroll position, or any programmatic
       scroll — goes from "below the viewport, not intersecting" to "above it,
       not intersecting" with no crossing and no callback, and the bar never
       appeared. Reading the rect is always correct for the current position.
       rAF-throttled and passive, so it costs nothing per scroll event. */
    var ticking = false;
    function update() {
      ticking = false;
      /* Show only once the real button has scrolled fully out of view upwards,
         so the bar never covers the button it duplicates. */
      show(anchor.getBoundingClientRect().bottom < 0);
    }
    function onScroll() {
      if (ticking) return;
      ticking = true;
      window.requestAnimationFrame(update);
    }
    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll, { passive: true });
    update();
  })();

  paint();
  /* Filter to the colour that is selected on load before the first render, so the
     gallery never flashes all 64 images. */
  if (colourIndexForFilter >= 0) filterGallery(selected[colourIndexForFilter]);
  render(findVariant(selected));
})();
